import { NativeStackScreenProps } from '@react-navigation/native-stack';

export enum DevToolsStackRoutes {
  Main = 'main',
  Button = 'button',
  Colours = 'colours',
  Icons = 'icons',
  Input = 'input',
  Typography = 'typography',
  BottomSheet = 'bottomSheet',
  Modal = 'modal',
  Table = 'table',
  Others = 'others'
}

export type DevToolsStackParamList = {
  [DevToolsStackRoutes.Main]: undefined;
  [DevToolsStackRoutes.Button]: undefined;
  [DevToolsStackRoutes.Colours]: undefined;
  [DevToolsStackRoutes.Icons]: undefined;
  [DevToolsStackRoutes.Input]: undefined;
  [DevToolsStackRoutes.Typography]: undefined;
  [DevToolsStackRoutes.BottomSheet]: undefined;
  [DevToolsStackRoutes.Modal]: undefined;
  [DevToolsStackRoutes.Table]: undefined;
  [DevToolsStackRoutes.Others]: undefined;
};

export type DevToolsStackScreenProps<Screen extends keyof DevToolsStackParamList> = NativeStackScreenProps<DevToolsStackParamList, Screen>;
